import { Image01Icon } from '@/components/ui/icons'
import { useTranslation } from '@/translations/i18n'

interface ProPhotosEmptyGalleryStateProps {
	uploadButton: React.ReactNode
	minimumImagesRequired: number
}

export const ProPhotosEmptyGalleryState = ({
	uploadButton,
	minimumImagesRequired
}: ProPhotosEmptyGalleryStateProps) => {
	const { t } = useTranslation()

	return (
		<div className='my-5 flex h-[360px] w-full flex-col items-center justify-center gap-1 rounded-2xl border-2 border-neutral-300 border-dashed'>
			<div className='flex w-full flex-col items-center justify-center gap-4'>
				<Image01Icon className='text-neutral-600' size={32} />
				<h3 className='font-medium text-neutral-900'>
					{t('vetting:reordering.dropzone_label')}
				</h3>
			</div>

			<p className='text-neutral-700 text-sm'>
				{t('vetting:reordering.at_least_x', {
					count: minimumImagesRequired
				})}
			</p>

			{uploadButton}
		</div>
	)
}
